export const documents = {
  ar: {
    title: 'الوثائق',
    upload: 'رفع ملف',
    download: 'تنزيل',
    delete: 'حذف',
    empty: 'لا توجد وثائق مرفوعة',
    uploading: 'جاري الرفع...',
    uploadSuccess: 'تم رفع الملف بنجاح',
    uploadError: 'حدث خطأ أثناء رفع الملف',
    deleteSuccess: 'تم حذف الوثيقة بنجاح',
    deleteError: 'حدث خطأ أثناء حذف الوثيقة',
    downloadError: 'حدث خطأ أثناء تنزيل الملف',
    confirmDelete: 'هل أنت متأكد من حذف هذا الملف؟',
    fileSizeExceeded: 'حجم الملف يتجاوز الحد المسموح (50 MB)',
    largeIcons: 'أيقونات كبيرة',
    mediumIcons: 'أيقونات متوسطة',
    smallIcons: 'أيقونات صغيرة',
    list: 'قائمة',
    details: 'تفاصيل',
    showPath: 'عرض المسار',
    hidePath: 'إخفاء المسار',
    copy: 'نسخ',
    copied: 'تم النسخ إلى الحافظة',
    copyError: 'فشل النسخ',
    preview: 'معاينة',
    close: 'إغلاق',
    loadingPreview: 'جاري تحميل المعاينة...',
    previewError: 'حدث خطأ أثناء تحميل المعاينة',
    previewNotSupported: 'لا يمكن معاينة هذا النوع من الملفات',
  },
  en: {
    title: 'Documents',
    upload: 'Upload File',
    download: 'Download',
    delete: 'Delete',
    empty: 'No documents uploaded',
    uploading: 'Uploading...',
    uploadSuccess: 'File uploaded successfully',
    uploadError: 'An error occurred while uploading the file',
    deleteSuccess: 'Document deleted successfully',
    deleteError: 'An error occurred while deleting the document',
    downloadError: 'An error occurred while downloading the file',
    confirmDelete: 'Are you sure you want to delete this file?',
    fileSizeExceeded: 'File size exceeds the allowed limit (50 MB)',
    largeIcons: 'Large Icons',
    mediumIcons: 'Medium Icons',
    smallIcons: 'Small Icons',
    list: 'List',
    details: 'Details',
    showPath: 'Show Path',
    hidePath: 'Hide Path',
    copy: 'Copy',
    copied: 'Copied to clipboard',
    copyError: 'Copy failed',
    preview: 'Preview',
    close: 'Close',
    loadingPreview: 'Loading preview...',
    previewError: 'Error loading preview',
    previewNotSupported: 'This file type cannot be previewed',
  },
}

